import BookParcel from './createParcel';

export default function editParcel() {
  return <BookParcel />;
}
